import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'

/**
 * axios 实例：统一处理 {code, message, data} 契约 + Authorization 头 + 401 弹登录框
 * 拦截器：code === 0 返回 data；否则 reject Error(message)
 */
/**
 * 登录态失效统一处理：只静默清掉本地登录态。
 *
 * 这里刻意 *不* 弹登录框、也 *不* 跳登录页：
 * 未登录时页面照常渲染（首页的余额、任务列表等接口返回 401 属正常），
 * 如果在这里弹窗，用户一进首页就会被打断，等于又回到"先登录才能用"。
 * 弹登录框只由用户【主动操作】触发：提交生成、上传素材，或进入需登录的页面。
 */
function handleUnauthorized() {
  localStorage.removeItem('ecomagent_token')
  store.commit('setAuth', { token: '', user: null })
}

const service = axios.create({
  baseURL: '/api/v1',
  timeout: 300000 // 生图/拆解可能较慢
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('ecomagent_token')
    if (token) {
      config.headers = config.headers || {}
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  err => Promise.reject(err)
)

service.interceptors.response.use(
  res => {
    const body = res.data
    if (body && typeof body === 'object' && typeof body.code === 'number') {
      if (body.code === 0) {
        return body.data
      }
      if (body.code === 401) {
        handleUnauthorized()
      }
      return Promise.reject(new Error(body.message || '請求失敗'))
    }
    return body
  },
  err => {
    if (err.response && err.response.status === 401) {
      handleUnauthorized()
    }
    const msg =
      (err.response && err.response.data && err.response.data.message) ||
      err.message ||
      '網路錯誤'
    return Promise.reject(new Error(msg))
  }
)

// 简化：统一错误提示（可选，避免重复 this.$message）
service.interceptors.response.use(undefined, err => {
  // 已在上方处理，这里只为保持 promise 链，不重复弹窗
  return Promise.reject(err)
})

export default service
